/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Roster_HintInputs */



/**
* | output |
* | --- |
* | "List only the players you know. The number above is the event's real size." |
*
* @param {Archival_Roster_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_roster_hint = /** @type {((inputs?: Archival_Roster_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Roster_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Listez seulement les joueurs que vous connaissez. Le nombre ci-dessus est la taille réelle du tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liste solo los jugadores que conozca. El número de arriba es el tamaño real del torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Liste só os jogadores que você conhece. O número acima é o tamanho real do torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenca solo i giocatori che conosci. Il numero qui sopra è la dimensione reale del torneo.")
	return /** @type {LocalizedString} */ ("List only the players you know. The number above is the event's real size.")
});